import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import api from '../../services/api';
import { toastError } from '../../toasts';
import { useAuth } from '../../hooks/auth';

export const useMounting = () => {
  const { id_empresa } = useAuth();
  const [montagens, setMontagens] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [buscar, setBuscar] = useState('');
  const [loading, setLoading] = useState(true);
  const [modalProdutos, setModalProdutos] = useState(false);
  const [modalMontagem, setModalMontagem] = useState(false);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [montagem, setMontagem] = useState(null);

  const atualizar = async () => {
    api
      .get(`montagem-prato/listarGestor/${id_empresa}`)
      .then((res) => {
        setMontagens(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
    api
      .get(`produto/listarProdutos/${id_empresa}`)
      .then((res) => {
        let produtosSelect = [];
        res.data.forEach((obj) => {
          if (obj.Ativo && obj.Disponivel) {
            const novoObj = { value: obj.Id, label: `${obj.Descricao}` };
            produtosSelect.push(novoObj);
          }
        });

        setProdutos(produtosSelect);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const alterarStatusMontagem = async (Id, status) => {
    try {
      const { data } = await api.patch(
        `montagem-prato/alterarStatusMontagem/${Id}`,
        {
          Ativo: status,
        },
      );

      setMontagens((prevState) =>
        prevState.map((e) => (e.Id !== data.Id ? e : data)),
      );
    } catch (error) {
      toastError('não foi possivel alterar status da montagem');
    }
  };

  const consultar = async (consulta) => {
    consulta = consulta.substring(4);
    if (!consulta) {
      atualizar();
      return;
    }
    try {
      const { data } = await api.post('montagem-prato/listarPorNomeGestor', {
        IdEmpresa: id_empresa,
        Consulta: consulta,
      });

      if (data.length > 0) {
        setMontagens(data);
        return;
      }

      setMontagens([]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao += filtroStatus !== '' ? ` AND Ativo='${filtroStatus}'` : ``;
    instrucao += value_lower
      ? ` AND LOWER(Descricao) LIKE '%${value_lower}%'`
      : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 1000);

  useEffect(() => {
    debounceSearch(buscar ?? '');
  }, [filtroStatus]);

  useEffect(() => {
    atualizar();
  }, []);

  return {
    montagens,
    produtos,
    loading,
    modalProdutos,
    setModalProdutos,
    modalMontagem,
    setModalMontagem,
    setFiltroStatus,
    montagem,
    setMontagem,
    alterarStatusMontagem,
    id_empresa,
    debounceSearch,
    filtroStatus,
    setMontagens,
  };
};
